import React from "react"
import classnames from "classnames"
import { Section, Container, H3, Content, InputText, Button, FormGroup, Space, LoadingSection } from "AtomicComponents"
import { AlertList } from "AtomicContainers"
import MESSAGES from "AtomicConstants/MESSAGES"
import componentParser from "AtomicUtils/componentParser"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import styles from "./MyNewMazda.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import fetchAPI from "AtomicUtils/fetchAPI"

class MyNewMazda extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        vinOrRego: {
          value: props.vinRego || "",
          validations: {
            required: MESSAGES.REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      loading: false
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { endpoint } = this.props
        const { form } = this.state
        const url = endpoint + "?vinrego=" + encodeURIComponent(form.vinOrRego.value)
        await fetchAPI({
          method: "POST",
          url: url,
          body: {}
        })
        .then(async (response) => {
          const json = await response.json()
          const { errorMessage, errorCode } = json

          if (response.status !== 200) {
            this.setState({
              errorMessage: errorMessage || MESSAGES[errorCode],
              loading: false
            })
          } else {
            // successful
            gtmHandler({
              pageCategory: "MyMazda",
              pageAction: `MyMazda Login - Enter VIN/Rego - Submitted "${form.vinOrRego.value.length > 6 ? "VIN" : "REGO"}"`
            })
            this.setState({
              success: true
            }, () => {
              const { redirectUrl } = this.props
              const url = new urlHandler(redirectUrl).buildNewUrl(json)
              new urlHandler(url).redirect()
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            loading: false
          })
        })
      })
    }
  }

  render() {
    const { heading, description, components } = this.props
    const { loading, errorMessage } = this.state

    return (
      <div>
        {componentParser(components,{},"",false)}
        <Section padding>
          <Container styleName='screen'>
            <div className={classnames({
              [styles.MyNewMazda]: true
            })}>
              <H3>{heading}</H3>
              <Content xmlString={description} />
              <div className={classnames({
                [styles.MyNewMazdaForm]: true
              })}>
                <form method="POST" onSubmit={this._handleSubmit}>
                  <FormGroup>
                    <div className={classnames({
                      [styles.MyNewMazdaFormWrapper]: true
                    })}>
                      <div className={classnames({
                        [styles.MyNewMazdaFormInput]: true
                      })}>
                        <InputText
                          name="vinOrRego"
                          label="ENTER VIN OR REGO"
                          {...fromLinkInputs(this, "vinOrRego")}
                        />
                      </div>
                      <div className={classnames({
                        [styles.MyNewMazdaFormButton]: true
                      })}>
                        <Button styleName="black" loading={loading} {...formLinkSubmit(this, this._handleSubmit)}>
                          View details
                        </Button>
                      </div>
                    </div>
                  </FormGroup>
                  {
                    loading &&
                    <div className={classnames({
                      [styles.MyNewMazdaLoadingSection]: true
                    })}>
                      <LoadingSection visible />
                    </div>
                  }
                  {
                    errorMessage &&
                    <FormGroup>
                      <Space />
                      <AlertList data={errorMessage} />
                    </FormGroup>
                  }
                </form>
              </div>
            </div>
          </Container>
        </Section>
      </div>
    )
  }
}

export default MyNewMazda



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyNewMazda/MyNewMazda.jsx